import WarehouseDataState from "@crescentParts/Store/Data/WarehouseData/WarehouseDataState"
import { get } from "@insite/client-framework/Services/ApiService"

export const getWarehouseData = async () => {
    const response = await get<WarehouseDataState>("/api/v2/DeliveryWarehouse");
    return response;
}